'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMinus, iconMinusTag } from '@ni/nimble-components/dist/esm/icons/minus';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMinus };
export { iconMinusTag };
export const NimbleIconMinus = wrap(IconMinus);